export const GENDER_LIST = [
  {
    _id: "Homme",
    name: "Homme",
    testId: "homme",
  },
  {
    _id: "Femme",
    name: "Femme",
    testId: "femme",
  },
  {
    _id: "Non-spécifié",
    name: "Non-spécifié",
    testId: "non-spécifié",
  },
];

// (old one don't use for recent feature)
export const selectForGenre = [
  {
    value: "Homme",
    title: "Homme",
    testId: "homme",
  },
  {
    value: "Femme",
    title: "Femme",
    testId: "femme",
  },
  {
    value: "Non-spécifié",
    title: "Non-spécifié",
    testId: "non-spécifié",
  },
];

export const JOBTYPE_LIST = [
  {
    value: "tempsPlein",
    name: "Temps plein",
  },
  {
    value: "tempsPartiel",
    name: "Temps partiel",
  },
  {
    value: "contractuel",
    name: "Contractuel",
  },
  {
    value: "temporaire",
    name: "Temporaire",
  },
  {
    value: "stage",
    name: "Stage",
  },
  {
    value: "benevolat",
    name: "Bénévolat",
  },
  {
    value: "alatache",
    name: "À la tache",
  },
  {
    value: "autre",
    name: "Autre",
  },
  {
    value: "permanent",
    name: "Permanent",
  },
  {
    value: "occasionnel",
    name: "Occasionnel",
  },
];

export const allLanguages = [
  //just the key but the value is on the traduction place public/en or public/fr
  "africain",
  "algérien",
  "allemand",
  "anglais",
  "arabe",
  "araméen",
  "arménien",
  "bengali",
  "berbère",
  "birman",
  "bosniaque",
  "brésilien",
  "bulgare",
  "cantonais",
  "catalan",
  "chypriote",
  "coréen",
  "croate",
  "créole",
  "danois",
  "ecossais",
  "egyptien",
  "espagnol",
  "espéranto",
  "estonien",
  "finlandais",
  "finnois",
  "flamand",
  "français",
  "gallois",
  "grec",
  "géorgien",
  "hawaïen",
  "hebreu",
  "hindi",
  "hollandais",
  "hongrois",
  "indonésien",
  "inuit",
  "irlandais",
  "islandais",
  "italien",
  "japonais",
  "javanais",
  "langue des signes",
  "latin",
  "lituanien",
  "malagasy",
  "malais",
  "malayalam",
  "mandarin",
  "norvégien",
  "népalais",
  "panjabi",
  "polonais",
  "portugais",
  "roumain",
  "russe",
  "sanskrit",
  "serbe",
  "slovaque",
  "slovène",
  "suédois",
  "tagalog",
  "tahitien",
  "tamoul",
  "tchèque",
  "thaï",
  "tibétain",
  "tsigane",
  "turc",
  "télougou",
  "ukrainien",
  "vietnamien",
  "wu",
];

export const LANGUAGE_LIST = allLanguages.map((language) => ({
  _id: language,
  name: language,
}));
